module.exports = __webpack_public_path__ + "static/soc1-dbc189f59abc6405024cde98b039c4eb.png";